(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonials-row-feather"] && !Shopify.designMode) return;
  try {
    

    const buttonScrollToTop = document.querySelector("#buttonScrollToTop");
    
    if(buttonScrollToTop){
      buttonScrollToTop.addEventListener("click", function (){
        // window.scrollTo(0,0);
        $("html, body").animate({ scrollTop: 450}, "slow");
    
    });
    }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-row"] && !Shopify.designMode) return;
  try {
    

    const buttonScrollToTop = document.querySelector("#buttonScrollToTop");
    
    if(buttonScrollToTop){
      buttonScrollToTop.addEventListener("click", function (){
        // window.scrollTo(0,0);
        $("html, body").animate({ scrollTop: 450}, "slow");
    
    });
    }
  

  } catch(e) { console.error(e); }
})();
})();
